import React from "react";
import { Alert } from "reactstrap";

const ValidationDivergencyAlert = ({
  onlyErrors,
  totalText,
  onVerify,
  onShowAll,
}) => {
  if (onlyErrors) {
    return (
      <Alert className="border-0 rounded-3 bg-light-blue-13">
        <div className="d-flex gap-3 align-items-center">
          <i
            style={{ width: 24, height: 24 }}
            className="fas fa-info text-white bg-light-blue-14 font-size-12 rounded-circle d-flex align-items-center justify-content-center"
          ></i>
          <span className="fw-semibold font-size-14 text-color-cinza4 p-0 m-0">
            Visualizar todos os Itens
          </span>
          <a
            className="fw-light font-size-12 text-color-azul4 text-decoration-underline cursor-pointer"
            onClick={onShowAll}
          >
            Exibir
          </a>
        </div>
      </Alert>
    );
  }

  return (
    <Alert
      color="danger"
      className="border-0 rounded-3"
      style={{ backgroundColor: "#EC221F40" }}
    >
      <div className="d-flex gap-3 align-items-center">
        <i
          style={{ width: 24, height: 24 }}
          className="fas fa-times text-white bg-color-vermelho1 font-size-12 rounded-circle d-flex align-items-center justify-content-center"
        ></i>
        <span className="fw-semibold font-size-14 text-color-vermelho2 p-0 m-0">
          {totalText}
        </span>
        <a
          className="fw-light font-size-12 text-color-vermelho2 text-decoration-underline cursor-pointer"
          onClick={onVerify}
        >
          Verificar
        </a>
      </div>
    </Alert>
  );
};

export default ValidationDivergencyAlert;
